import { render, staticRenderFns } from "./EditoPopin.vue?vue&type=template&id=b954ba48&"
import script from "./EditoPopin.vue?vue&type=script&lang=ts&"
export * from "./EditoPopin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b954ba48')) {
      api.createRecord('b954ba48', component.options)
    } else {
      api.reload('b954ba48', component.options)
    }
    module.hot.accept("./EditoPopin.vue?vue&type=template&id=b954ba48&", function () {
      api.rerender('b954ba48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/common/components/vue/EditoPopin.vue"
export default component.exports